import { useState, useEffect, useRef } from 'react';

const EditableField = ({ value, fieldKey, onSave, multiline = false, style = {}, className = '' }) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value);
  const [hovered, setHovered] = useState(false);
  const ref = useRef(null);

  useEffect(() => { setDraft(value); }, [value]);
  useEffect(() => { if (editing && ref.current) ref.current.focus(); }, [editing]);

  const commit = () => {
    setEditing(false);
    if (draft !== value) onSave(fieldKey, draft);
  };

  if (editing) {
    const shared = {
      ref,
      value: draft,
      onChange: e => setDraft(e.target.value),
      onBlur: commit,
      onKeyDown: e => { if (!multiline && e.key === 'Enter') { e.preventDefault(); commit(); } if (e.key === 'Escape') { setDraft(value); setEditing(false); } },
      style: { width: '100%', background: 'rgba(255,255,255,0.12)', border: '2px solid #f59e0b', borderRadius: 6, padding: '0.4rem 0.6rem', color: 'inherit', font: 'inherit', fontSize: 'inherit', fontWeight: 'inherit', lineHeight: 'inherit', resize: multiline ? 'vertical' : 'none', outline: 'none', boxSizing: 'border-box', ...style },
    };
    return multiline
      ? <textarea rows={Math.max(3, (draft || '').split('\n').length + 1)} {...shared} />
      : <input {...shared} />;
  }

  return (
    <span
      style={{ display: 'inline', cursor: 'text', borderRadius: 4, transition: 'background 0.15s', background: hovered ? 'rgba(245,158,11,0.18)' : 'transparent', ...style }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => setEditing(true)}
      className={className}
      title="Click to edit"
    >
      {value}<span style={{ display: 'inline-block', fontSize: '0.75em', marginLeft: '0.4em', background: '#f59e0b', color: '#fff', borderRadius: 4, padding: '1px 5px', verticalAlign: 'middle', userSelect: 'none', opacity: hovered ? 1 : 0.7, transition: 'opacity 0.15s' }}>✏️ edit</span>
    </span>
  );
};

export default EditableField;
